import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";

import Navbar from "./components/Navbar";
// import QueryPopup from "./components/QueryPopup";
import Home from "./components/Home";
import Footer from "./components/Footer";
import AboutUs from "./components/AboutUs";
import ContactUs from "./components/ContactUs";
import Hinge from "./components/categories/Hinge";
import TelescopicChannel from "./components/categories/TelescopicChannel";
import MultiuseBasket from "./components/categories/MultiuseBasket";
import SlimBox from "./components/categories/SlimBox";
import CornerSolutions from "./components/categories/CornerSolutions";
import PullOut from "./components/categories/PullOut";
import Basket from "./components/categories/Basket";
import PipeBasket from "./components/categories/PipeBasket";
import RollingShutters from "./components/categories/RollingShutters";
import DoorCloser from "./components/categories/DoorCloser";
import DoorFitting from "./components/categories/DoorFitting";
import FoldingBracket from "./components/categories/FoldingBracket";
import DrawerFitting from "./components/categories/DrawerFitting";
import KitchenAccessories from "./components/categories/KitchenAccessories";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsConditions from "./components/TermsConditions";
import CabinetHingesInstallation from "./components/CabinetHingesInstallation";
import StatePage from "./components/StatePage";
import KitchensBasket from "./components/categories/KitchensBasket";
import AluminiumProfile from "./components/categories/AluminiumProfile";
import Catalogue from "./components/Catalogue";
import PriceList from "./components/PriceList";
import Blog from "./pages/Blogs";
import BlogDetails from "./pages/BlogDetails";
import AdminLogin from "./pages/AdminLogin";
import BlogDashboard from "./pages/BlogDashboard";
import ManageBlogs from "./pages/ManageBlogs";
import ProtectedRoute from "./pages/ProtectedRoute";


function App() {
  return (
    <BrowserRouter>
      <Navbar />
      {/* <QueryPopup /> */}
      <Routes>
 
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/cabinet-hinges" element={<Hinge />} />
        <Route path="/telescopic-channel" element={<TelescopicChannel />} />
        <Route path="/multiuseBasket" element={<MultiuseBasket />} />
        <Route path="/corner-solutions" element={<CornerSolutions />} />
        <Route path="/slim-box" element={<SlimBox />} />
        <Route path="/pull-out" element={<PullOut />} />
        <Route path="/basket" element={<Basket />} />
        <Route path="/door-closer" element={<DoorCloser />} />
        <Route path="/door-fitting" element={<DoorFitting />} />
        <Route path="/folding-bracket" element={<FoldingBracket />} />
        <Route path="/rolling-shutter" element={<RollingShutters />} />
        <Route path="/pipe-basket" element={<PipeBasket />} />
        <Route path="/pipe-basket/:slug" element={<MultiuseBasket />} />
        <Route path="/drawer-fitting" element={<DrawerFitting />} />
        <Route path="/kitchen-Accessories" element={<KitchenAccessories />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/cabinethingesinstallation" element={<CabinetHingesInstallation />} />
      
        <Route path="/hardware-in/:stateName" element={<StatePage />} />
        <Route path="/hardware-in/:stateName/:cityName" element={<StatePage />} />
        <Route path="/kitchen-baskets" element={<KitchensBasket />} />
   <Route path="/kitchen-baskets" element={<KitchensBasket />} />
<Route path="/aluminium-profile" element={<AluminiumProfile />} />

  <Route path="/catalogue.pdf" element={<Catalogue />}
        />
        <Route path="/price-list.pdf" element={<PriceList />} />

        {/* Blog Public Routes */}
        <Route path="/blogs" element={<Blog />} />
        <Route path="/blogs/:slug" element={<BlogDetails />} />

        {/* Admin Routes - Protected */}
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <BlogDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-blogs"
          element={
            <ProtectedRoute>
              <ManageBlogs />
            </ProtectedRoute>
          }
        />
      </Routes>

      <a
        href="https://wa.me/919650100908?text=Hello%20I%20want%20hardware%20details"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
         aria-label="Chat on WhatsApp"
      >
        <FaWhatsapp />
      </a>

      <Footer />
    </BrowserRouter>
  );
}

export default App;
